export default "__VITE_ASSET__C0Zy8_vo__"